import React from 'react'
import { Row, Col} from 'antd'
import CardTotalCost from '../Cards/card-total-cost'
import CardStorageUsage from '../Cards/card-storage-usage'
import CardBucketCount from '../Cards/card-bucket-count'
import StorageUsageChart from './storage-usage-chart'
import './storage-usage.scss'


export default ({selectedAccount, storageUsageChartData, totalCost}) => { 
    let data = new window.google.visualization.DataTable()
    let formatter = new window.google.visualization.NumberFormat({
      pattern: ',###.## GB',
      fractionDigits: 2
    })

    data.addColumn('string', 'Topping')
    data.addColumn('number', 'Slices')
    
    if (storageUsageChartData.length > 0)
    {
        let metricChart = []

        storageUsageChartData.map((st) => {
            metricChart.push([st[0],((st[1]/1024)/1024)/1024])
        })

        data.addRows(metricChart)
        formatter.format(data, 1)
    }      

    return (
    <div>
    <div>
        <Row type="flex" gutter={30} className="overview-container">
        <Col span={6}>
                <Row type="flex" className="rowStyle">
                    <Col span={24}>
                        <CardTotalCost title="Total S3 Cost" totalCost={totalCost} />
                    </Col>
                </Row>
                <Row className="rowStyle">
                    <Col span={24}>
                        <CardStorageUsage storageUsage={selectedAccount.total_bytes_used} />
                    </Col>
                </Row>
                <Row>
                    <Col span={24}>
                        <CardBucketCount bucketCount={selectedAccount.bucket_count} />
                    </Col>
                </Row>
            </Col>

            <Col span={18}>
                <div className="overview-chart-container">
                   <StorageUsageChart storageUsageChartData={data} /> 
                </div>
            </Col>
        </Row>
    </div>

    </div>
)}